export enum CompanyRoles {
    Exporter = 'Exporter',
    Importer = 'Importer',
    Admin = 'Admin'
}